import { Authenticator } from "@aws-amplify/ui-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import InitColorSchemeScript from "@mui/material/InitColorSchemeScript";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./state/configureStore";

import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container);
const store = configureStore();

root.render(
  <StrictMode>
    <InitColorSchemeScript />
    <Provider store={store}>
      <Router>
        <Authenticator.Provider>
          <App />
        </Authenticator.Provider>
      </Router>
    </Provider>
  </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
